import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import Content from "../../../components/Export/Content";
import Column from "../../../components/Export/Column";
import Table from "../../../components/Export/Table";
import Table2 from "../../../components/Export/Table2";
import Row from "../../../components/Export/Row";

import "./SaleConsumptionSummary.css";
import Spinner from "../../../components/UI/Spinner/Spinner";
import Filter from "../../../helpers/Filter";
import Axios from "axios";
import NoData from "../../../components/UI/Spinner/NoData";
import Configs from "../../../Configs";

const styleRow = {};

const styleRowTotal = {
  borderBottom: "2px solid #f4f4f4",
  borderTop: "2px solid #f4f4f4",
};

const title = {};

class SaleConsumptionImportSummary extends React.PureComponent {
  state = {
    reports: [],
    analysis: {},
    loading: false,
    noFile: false,
  };

  componentDidMount() {
    this.setState({
      loading: true,
    });
    Axios.get(`${this.props.file}`)
      .then((res) => {
        this.setState({
          analysis: res.data,
          loading: false,
          noFile: false,
        });
      })
      .catch((res) => {
        this.setState({
          loading: false,
          noFile: true,
        });
      });
  }

  exportPdf = () => {
    let view = document.getElementById("exportReceptBill").innerHTML;
    let popupWinindow = window.open(
      "",
      "_blank",
      "width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
    );
    popupWinindow.document.open();
    popupWinindow.document.write(
      '<html><head><link rel="stylesheet" type="text/css" href="' +
        Configs.abossUrl +
        '/assets/css/bootstrap.min.css" /></head><body onload="window.print()">' +
        view +
        "</html>"
    );
    popupWinindow.document.close();
  };

  calculateRoundValue = (value, numOfDecimalPlace, showLessValue) => {
    var partOne = 0;
    var demValue = "1";
    for (var d = 0; d < numOfDecimalPlace; d++) {
      demValue = demValue.toString() + "0".toString();
    }
    demValue = Number(demValue);
    if (value != 0 && value != undefined) {
      partOne = Math.round(value * demValue) / demValue;
    }
    if (showLessValue) {
      partOne = partOne * -1;
    }
    return partOne;
  };

  calculateRoundNumberValue = (value, numOfDecimalPlace, showLessValue) => {
    var partOne = 0;
    var demValue = "1";
    for (var d = 0; d < numOfDecimalPlace; d++) {
      demValue = demValue.toString() + "0".toString();
    }
    demValue = Number(demValue);
    if (value != 0 && value != undefined) {
      partOne = Math.round(value * demValue) / demValue;
    }
    if (showLessValue) {
      partOne = partOne * -1;
    }
    return Filter.displayNumber(partOne);
  };

  setSaleItemsTable = (results, usageIds, payType, tableTitle, period) => {
    let values = [];
    let totalItemSalePrice = 0;
    let totalQuantity = 0;
    let totalCostPrice = 0;
    let totalMargin = 0;
    const usageIdsLength = usageIds.length;
    for (var m = 0; m < usageIdsLength; m++) {
      const usageId = usageIds[m];
      const summary =
        results["sales_items_" + payType + "_" + usageId + "_" + period];
      if (summary === undefined) {
        continue;
      }
      const itemSalePrice = summary.totalItemSalesPrice || 0;
      const itemQuantity = summary.totalQuantity || 0;
      const costPrice = summary.totalCostPrice || 0;
      const margin = summary.totalMargin || 0;
      let marginPercent = 0;
      if (itemSalePrice !== 0) {
        marginPercent = Filter.displayCurrency(margin / itemSalePrice) * 100;
      }
      values.push({
        name: summary.nameOfStock,
        val: [
          Filter.displayNumber(itemQuantity),
          Filter.displayCurrency(itemSalePrice),
          Filter.displayCurrency(costPrice),
          Filter.displayCurrency(margin),
          Filter.displayCurrency(marginPercent) + "%",
        ],
      });
      totalItemSalePrice = totalItemSalePrice + itemSalePrice;
      totalQuantity = totalQuantity + itemQuantity;
      totalCostPrice = totalCostPrice + costPrice;
      totalMargin = totalMargin + margin;
    }

    values.sort((a, b) => (a.name > b.name ? 1 : -1));

    let totalMarginPercent = 0;
    if (totalItemSalePrice !== 0) {
      totalMarginPercent =
        Filter.displayCurrency(totalMargin / totalItemSalePrice) * 100;
    }
    values.push({
      name: "Total",
      val: [
        Filter.displayNumber(totalQuantity),
        Filter.displayCurrency(totalItemSalePrice),
        Filter.displayCurrency(totalCostPrice),
        Filter.displayCurrency(totalMargin),
        Filter.displayCurrency(totalMarginPercent) + "%",
      ],
    });

    return (
      <Table2 title={tableTitle} col={4}>
        <Row
          styleRow={styleRowTotal}
          name={"Name of Sales Item"}
          values={[
            "Quantiy",
            "Item Sales",
            "Cost Price",
            "Gross Profit",
            "Margin",
          ]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  setStockItemsTable = (results, salesNames, payType, tableTitle, period) => {
    let values = [];
    let totalUnit = 0;
    let totalDisplay = 0;
    let totalCostPrice = 0;
    const salesNamesLength = salesNames.length;
    for (var m = 0; m < salesNamesLength; m++) {
      const salesName = salesNames[m];
      const summary =
        results["stock_items_" + payType + "_" + salesName + "_" + period];
      if (summary === undefined) {
        continue;
      }
      const unit = summary.totalUnit || 0;
      const costPrice = summary.totalCostPrice || 0;
      const display = summary.totalDisplay || 0;
      values.push({
        name: summary.nameOfStock,
        val: [
          Filter.displayNumber(unit) + " " + summary.unitUsage,
          this.calculateRoundValue(display, 4, false) +
            " " +
            summary.displayUsage,
          Filter.displayCurrency(costPrice),
        ],
      });
      totalUnit = totalUnit + unit;
      totalDisplay = totalDisplay + display;
      totalCostPrice = totalCostPrice + costPrice;
    }

    values.push({
      name: "Total",
      val: ["", "", Filter.displayCurrency(totalCostPrice)],
    });

    return (
      <Table2 title={tableTitle}>
        <Row
          styleRow={styleRowTotal}
          name={"Name of Stock"}
          values={["Total Unit", "Total Display", "Total Cost Price"]}
        ></Row>
        {values.map((value, key) => {
          if (value.name === "Total") {
            return (
              <Row
                key={key}
                styleRow={styleRowTotal}
                name={"Total"}
                values={value.val}
              ></Row>
            );
          }
          return (
            <Row
              key={key}
              styleRow={styleRow}
              name={value.name}
              values={value.val}
            ></Row>
          );
        })}
      </Table2>
    );
  };

  render() {
    let content = <Spinner></Spinner>;

    if (this.state.noFile) {
      return <NoData></NoData>;
    }

    if (!this.state.loading && Object.keys(this.state.analysis).length > 0) {
      const analysis = { ...this.state.analysis };

      const periods = [...analysis.periods];
      let controllerNames = { ...analysis.controllerNames };
      const controllers = [...analysis.controllerIds];
      const controllersName = [];
      const controllersLength = controllers.length;
      for (let i = 0; i < controllersLength; i++) {
        if (controllerNames[controllers[i]] !== undefined) {
          controllersName.push(controllerNames[controllers[i]]);
        }
      }
      const payTypes = [...analysis.payTypes];
      const summaryConsumption = { ...analysis.summaryConsumption };
      const usageIds = [...analysis.usageIds];
      const salesNames = [...analysis.salesNames];

      content = null;
      content = periods.map((period, key) => {
        const start = period.range.start;
        const end = period.range.end;
        const description = `FROM ${moment(+start).format("LLL")} TO ${moment(
          +end
        )
          .subtract(1, "minutes")
          .format("LLL")}`;

        const contentChild = payTypes.map((payType, key) => {
          return (
            <table
              key={key}
              style={{
                width: "100%",
              }}
            >
              <tbody>
                <tr>
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "100%",
                    }}
                  >
                    <Table title={`Sale ${payType}`}></Table>
                  </Column>
                </tr>
                <tr>
                  <Column
                    style={{
                      margin: "10px 0px 0px 0px",
                      background: "white",
                      verticalAlign: "top",
                      width: "100%",
                    }}
                  >
                    {this.setSaleItemsTable(
                      summaryConsumption,
                      salesNames,
                      payType,
                      "SALES ITEMS",
                      period.name
                    )}
                    {this.setStockItemsTable(
                      summaryConsumption,
                      usageIds,
                      payType,
                      "STOCK ITEMS",
                      period.name
                    )}
                  </Column>
                </tr>
                <tr>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                  <td>&nbsp;</td>
                </tr>
                {key + 1 !== payTypes.length ? (
                  <tr
                    style={{
                      borderTop: "2px solid black",
                    }}
                  >
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          );
        });

        return (
          <Content
            key={key}
            title="SALES CONSUMPTION SUMMARY"
            description={description}
            controllers={controllersName.join(", ")}
          >
            {contentChild}
          </Content>
        );
      });
    }

    return (
      <div className="ReceptBillSummary">
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <button className="btn btn-primary" onClick={this.exportPdf}>
              <i className="fa fa-print"></i>
              Print
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xs-12 col-lg-12">
            <div id="exportReceptBill">{content}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default SaleConsumptionImportSummary;
